import { Autocomplete, debounce } from "@mui/material";
import { SearchProduct } from "../../engine/baseApiClient";
import * as React from 'react';
import TextField from '@mui/material/TextField';
import { useGridApiContext } from '@mui/x-data-grid';
import ProductSearchResultCard from "./components/ProductSearchResultCard/ProductSearchResultCard";
import * as Styled from './ProductSearchControl.styles.js';

export default function  ProductSearchControl(props) {
    const onProductDataSet = props.onProductDataSet;
    const apiRef = useGridApiContext();
   
    const onChangeHandler = (e, newValue) => {
        e.stopPropagation();
        var field = props.field;
        var id = props.id;

        if(newValue != null && (typeof newValue !== 'string')) {
            onProductDataSet(id, newValue.id, newValue.product); 
            apiRef.current.setEditCellValue({ id, field, value:  newValue.product.name });
        }
        
        apiRef.current.stopCellEditMode({ id, field, ignoreModifications: false });
    }

    const onValueChangedHandler = (newValue) => {
        var field = props.field;
        var id = props.id;
        apiRef.current.setEditCellValue({ id, field, value:  newValue });
    }
  
    const onTextInputFocus = (e) => { e.target.select(); }    

    const [productsAutocompleteList, setProductsAutocompleteList] = React.useState([]);
    const throttledSearchProduct = React.useMemo(() => debounce((e, searchString) => { 
        searchProduct(e, searchString) 
    }, 500), []);

    const searchProduct = async (e, searchString) => {
        if(searchString != '' && searchString.length > 2) {
            const searchResults = await SearchProduct(searchString);

            if(searchResults === undefined || searchResults.length === 0) {
                searchResults.push('Brak wyników wyszukiwania');
            };

            setProductsAutocompleteList(searchResults);
        }
        else { 
            setProductsAutocompleteList([]); 
        }
    }

    return (
        <Autocomplete
        autoComplete 
        filterSelectedOptions
        freeSolo
        disableClearable
        filterOptions={ (x) => x }
        value={props.value}
        fullWidth   
        onChange={onChangeHandler}
        noOptionsText='Brak wyników wyszukiwania'
        options={ productsAutocompleteList }
        renderOption={(props, option, state) => {
            return (
                typeof option === 'string' ?  
                <li {...props}>{option}</li> :                    
                <li {...props}><ProductSearchResultCard data={option.product}/></li>
            )
        }}
        getOptionLabel={(value) => {
            return (typeof value === 'string') ? value : value.product.name;
        }}
        renderInput={(params) => (<TextField autoFocus onFocus={onTextInputFocus} onChange={(e) => onValueChangedHandler(e.target.value)} {...params}/>)}
        onInputChange={ (event, newInputValue) => { throttledSearchProduct(event, newInputValue); }}
      />
    );
}
